var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"app",staticClass:"app",attrs:{"id":"app"}},[_c('MainHeader'),_c('main',{staticClass:"site-main"},[_c('router-view')],1),_c('PartBackToTop')],1)}
var staticRenderFns = []

export { render, staticRenderFns }